module.exports = __webpack_public_path__ + "img/reception-4.e0207b44.svg";